import { createAction as ca } from 'redux-actions';
import * as types from './actiontypes';

function createAction(foo, bar) {
  const fun = ca(foo, bar);
  return args => {
    console.debug('CALLING ACTION', foo);
    return fun(args);
  };
}

/* eslint-disable max-len */
// ******************* LOCALES ************************/
export const changeLocale = createAction(types.LOCALE.SET);
export const resetLocale = createAction(types.LOCALE.CLEAR);

// ******************* LOCALITIES ************************/
export const fetchLocalities = createAction(types.LOCALITIES.FETCH);
export const receiveLocalities = createAction(types.LOCALITIES.RECEIVE);
export const failLocalities = createAction(types.LOCALITIES.FAIL);
export const fetchRegions = createAction(types.REGIONS.FETCH);
export const receiveRegions = createAction(types.REGIONS.RECEIVE);
export const failRegions = createAction(types.REGIONS.FAIL);

// ******************* LOGIN / AUTH ************************/
export const onLogin = createAction(types.LOGIN.CLIENT);
export const login = createAction(types.CLIENT.SET);
export const logout = createAction(types.CLIENT.CLEAR);
export const authenticate = createAction(types.AUTH.SET);
export const invalidLogin = createAction(types.AUTH.INVALID);
export const fetchAuthenticationForms = createAction(types.AUTH.FETCH);
export const receiveAuthenticationForms = createAction(types.AUTH.RECEIVE);
export const onTokenLogin = createAction(types.LOGIN.TOKEN);
export const tokenLoginChecked = createAction(types.LOGIN.TOKENCHECKED);
export const checkPermission = createAction(types.PERMISSION);

// ******************* LICENSES ************************/
export const fetchLicenses = createAction(types.LICENSES.FETCH);
export const fetchLicensesFail = createAction(types.LICENSES.FAIL);
export const receiveLicenses = createAction(types.LICENSES.RECEIVE);
export const listLicenses = createAction(types.LICENSES.LIST);
export const listLicensesSuccess = createAction(types.LICENSES.LIST_SUCCESS);
export const listLicensesFail = createAction(types.LICENSES.LIST_FAIL);
export const fetchLicenseLogs = createAction(types.LICENSE_LOGS.FETCH);
export const fetchLicenseLogsFail = createAction(types.LICENSE_LOGS.FAIL);
export const receiveLicenseLogs = createAction(types.LICENSE_LOGS.RECEIVE);
export const activateLicense = createAction(types.LICENSE.SAVE);
export const activateLicenseFail = createAction(types.LICENSE.FAIL);
export const activateLicenseSuccess = createAction(types.LICENSE.RESULT);
export const deactivateLicense = createAction(types.LICENSE.DEACTIVATE);
export const deactivateLicenseFail = createAction(types.LICENSE.DEACTIVATE_FAIL);
export const deactivateLicenseSuccess = createAction(types.LICENSE.DEACTIVATE_SUCCESS);
export const updateLicense = createAction(types.LICENSE.UPDATE);
export const updateLicenseFail = createAction(types.LICENSE.UPDATE_FAIL);
export const updateLicenseSuccess = createAction(types.LICENSE.UPDATE_SUCCESS);
export const upgradeLicense = createAction(types.LICENSE.UPGRADE);
export const upgradeLicenseFail = createAction(types.LICENSE.UPGRADE_FAIL);
export const upgradeLicenseSuccess = createAction(types.LICENSE.UPGRADE_SUCCESS);
export const fetchLicenseTypes = createAction(types.LICENSE_TYPES.FETCH);
export const fetchLicenseTypesFail = createAction(types.LICENSE_TYPES.FAIL);
export const receiveLicenseTypes = createAction(types.LICENSE_TYPES.RECEIVE);

export const fetchSellers = createAction(types.SELLERS.FETCH);
export const fetchSellersFail = createAction(types.SELLERS.FAIL);
export const receiveSellers = createAction(types.SELLERS.RECEIVE);

export const exportLicenses = createAction(types.LICENSES.EXPORT);
export const exportLicensesSuccess = createAction(types.LICENSES.EXPORT_SUCCESS);
export const exportLicensesFail = createAction(types.LICENSES.EXPORT_FAIL);
export const importLicenses = createAction(types.LICENSES.IMPORT);
export const importLicensesSuccess = createAction(types.LICENSES.IMPORT_SUCCESS);
export const importLicensesFail = createAction(types.LICENSES.IMPORT_FAIL);

export const fetchLicensePayments = createAction(types.LICENSE_PAYMENTS.FETCH);
export const fetchLicensePaymentsFail = createAction(types.LICENSE_PAYMENTS.FETCH_FAIL);
export const receiveLicensePayments = createAction(types.LICENSE_PAYMENTS.RECEIVE);
export const saveLicensePayment = createAction(types.LICENSE_PAYMENTS.SAVE);
export const saveLicensePaymentSuccess = createAction(types.LICENSE_PAYMENTS.RESULT);
export const saveLicensePaymentFail = createAction(types.LICENSE_PAYMENTS.FAIL);

export const fetchCompanyLicenses = createAction(types.COMPANY_LICENSES.FETCH);
export const fetchCompanyLicensesFail = createAction(types.COMPANY_LICENSES.FAIL);
export const receiveCompanyLicenses = createAction(types.COMPANY_LICENSES.RECEIVE);

// ******************* CONTACT PERSONS ************************/
export const fetchContactPersons = createAction(types.CONTACT_PERSONS.FETCH);
export const receiveContactPersons = createAction(types.CONTACT_PERSONS.RECEIVE);
export const fetchContactPersonsFail = createAction(types.CONTACT_PERSONS.FAIL);

export const addContactPerson = createAction(types.CONTACT_PERSON.ADD);
export const addContactPersonSuccess = createAction(types.CONTACT_PERSON.ADD_SUCCESS);
export const addContactPersonFail = createAction(types.CONTACT_PERSON.ADD_FAIL);

export const updateContactPerson = createAction(types.CONTACT_PERSON.UPDATE);
export const updateContactPersonSuccess = createAction(types.CONTACT_PERSON.UPDATE_SUCCESS);
export const updateContactPersonFail = createAction(types.CONTACT_PERSON.UPDATE_FAIL);

// ******************* ACTION LOG ************************/
export const setActionLog = createAction(types.ACTION_LOG.SET);
export const clearActionLog = createAction(types.ACTION_LOG.CLEAR);

// ******************* REPORT ************************/
export const fetchReport = createAction(types.REPORT.FETCH);
// FAIL is now reserved for failing fetch action
export const fetchReportFail = createAction(types.REPORT.FAIL);
export const receiveReport = createAction(types.REPORT.RECEIVE);
export const saveReport = createAction(types.REPORT.SAVE);
export const setReport = createAction(types.REPORT.SET);
export const clearReport = createAction(types.REPORT.CLEAR);

// ******************* EDITING ************************/
export const setEditing = createAction(types.EDITING.SET);
export const clearEditing = createAction(types.EDITING.CLEAR);
export const setReportEditable = createAction(types.REPORT_EDITABLE.SET);
export const clearReportEditable = createAction(types.REPORT_EDITABLE.CLEAR);

// ******************* REVIEWS ************************/
export const saveReview = createAction(types.REVIEW.SAVE);
export const fetchReview = createAction(types.REVIEW.FETCH);
export const receiveReview = createAction(types.REVIEW.RECEIVE);
export const failReview = createAction(types.REVIEW.FAIL);

export const fetchReviewsByCompany = createAction(types.COMPANY_REVIEWS.FETCH);
export const receiveReviewsByCompany = createAction(types.COMPANY_REVIEWS.RECEIVE);
export const setReviewsByCompany = createAction(types.COMPANY_REVIEWS.SET);
export const clearReviewsByCompany = createAction(types.COMPANY_REVIEWS.CLEAR);

export const fetchReviewsByUser = createAction(types.USER_REVIEWS.FETCH);
export const receiveReviewsByUser = createAction(types.USER_REVIEWS.RECEIVE);
export const setReviewsByUser = createAction(types.USER_REVIEWS.SET);
export const clearReviewsByUser = createAction(types.USER_REVIEWS.CLEAR);

export const fetchTopReviewers = createAction(types.TOP_REVIEWERS.FETCH);
export const receiveTopReviewers = createAction(types.TOP_REVIEWERS.RECEIVE);

export const fetchTopCompanies = createAction(types.TOP_COMPANIES.FETCH);
export const receiveTopCompanies = createAction(types.TOP_COMPANIES.RECEIVE);

// ******************* PIACE ************************/
export const savePiace = createAction(types.PIACE.SAVE);
export const fetchPiace = createAction(types.PIACE.FETCH);
export const receivePiace = createAction(types.PIACE.RECEIVE);
export const failPiace = createAction(types.PIACE.FAIL);

// ******************* CHAT ************************/
export const fetchChat = createAction(types.CHAT.FETCH);
export const fetchChatFail = createAction(types.CHAT.FETCH_FAIL);
export const receiveChat = createAction(types.CHAT.RECEIVE);
export const saveChat = createAction(types.CHAT.SAVE);
export const startChat = createAction(types.CHAT.START);
export const getChats = createAction(types.CHAT.LIST);
export const receiveChatList = createAction(types.CHAT.RECEIVELIST);

// ******************* PAGES/NAV ************************/
export const navigate = createAction(types.NAVIGATE); // , (to) => to
export const start = createAction(types.START);

// ******************* PORTFOLIO ************************/
export const fetchPortfolio = createAction(types.PORTFOLIO.FETCH);
export const receivePortfolio = createAction(types.PORTFOLIO.RECEIVE);
export const failPortfolio = createAction(types.PORTFOLIO.FAIL);
export const removePortfolioSlide = createAction(types.PORTFOLIO.REMOVE_SLIDE);
export const addPortfolioSlide = createAction(types.PORTFOLIO.ADD_SLIDE);
export const updatePortfolioField = createAction(types.PORTFOLIO.UPDATE_FIELD);
export const savePortfolio = createAction(types.PORTFOLIO.SAVE);
export const savePortfolioSuccess = createAction(types.PORTFOLIO.RESULT);
export const uploadPortfolioImage = createAction(types.PORTFOLIO.UPLOAD_IMAGE);
export const receivePortfolioImage = createAction(types.PORTFOLIO.RECEIVE_IMAGE);
export const updatePortfolioCompanyField = createAction(types.PORTFOLIO.UPDATE_COMPANY_FIELD);
export const uploadPortfolioCompanyLogo = createAction(types.PORTFOLIO.UPLOAD_LOGO);
export const receivePortfolioCompanyLogo = createAction(types.PORTFOLIO.RECEIVE_LOGO);
export const recoverSlides = createAction(types.PORTFOLIO.RECOVER_SLIDES);
export const onEnablePortfolio = createAction(types.PORTFOLIO.ENABLE);
export const onDisablePortfolio = createAction(types.PORTFOLIO.DISABLE);
export const receiveEnablePortfolio = createAction(types.PORTFOLIO.RECEIVE_ENABLE);
export const onShowPortfolio = createAction(types.PORTFOLIO.SHOW);
export const onHidePortfolio = createAction(types.PORTFOLIO.HIDE);

// ******************* PAID FEATURES ************************/
export const saveKeywords = createAction(types.PAID.SAVE_KEYWORDS);
export const updateKeywords = createAction(types.PAID.UPDATE_KEYWORDS);
export const receiveKeywords = createAction(types.PAID.RECEIVE_KEYWORDS);
export const fetchKeywords = createAction(types.PAID.FETCH_KEYWORDS);

export const saveCompanyRegions = createAction(types.PAID.SAVE_COMPANY_REGIONS);
export const failSaveCompanyRegions = createAction(types.PAID.FAIL_SAVE_COMPANY_REGIONS);
export const receiveCompanyRegions = createAction(types.PAID.RECEIVE_COMPANY_REGIONS);
export const fetchCompanyRegions = createAction(types.PAID.FETCH_COMPANY_REGIONS);

// ******************* RELIABLE PARTNER QUICK CHECK ************************/
export const fetchRPQuickCheck = createAction(types.RP_QUICK_CHECK.FETCH);
export const fetchRPQuickCheckRecieve = createAction(types.RP_QUICK_CHECK.RECEIVE);
export const fetchRPQuickCheckFail = createAction(types.RP_QUICK_CHECK.FAIL);

// ******************* CL REPORTS ************************/
export const fetchCLReport = createAction(types.CL_REPORT.FETCH);
export const fetchCLReportReceive = createAction(types.CL_REPORT.RECEIVE);
export const fetchCLReportFail = createAction(types.CL_REPORT.FAIL);
